import { useBooleanFlagValue } from "@openfeature/react-sdk";

import FeatureFlags, { FeatureFlagDefaults } from "@/utils/featureFlags";

const useFlag = (flag: FeatureFlags): boolean =>
  useBooleanFlagValue(flag, FeatureFlagDefaults[flag]);

export default useFlag;
